import { ATTR_NAME } from 'constants/attr-name'
import { CLASS_NAME } from 'constants/class-names'
import { EventType } from 'constants/enums'
import { Nullable } from 'constants/types'
import { ComponentBase } from 'utils/abstract-classes/component-base'

const { common: commonClass, characterCount: className } = CLASS_NAME
const { characterCount: attrs } = ATTR_NAME.main

export class CharacterCountComponent extends ComponentBase {
    public maxLength: number
    public minLength: number

    private fieldMessage: Nullable<HTMLElement>
    private count: HTMLInputElement
    private counterValueWrap: Nullable<HTMLElement>
    private counterValue: Nullable<HTMLElement>

    public constructor(private field: HTMLElement) {
        super()

        const countEl = this.getElement<HTMLInputElement>(
            `.${commonClass.formControl}`,
            this.field
        )

        if (!countEl) {
            // no input to count, quit
            return
        }

        this.count = countEl

        this.maxLength =
            parseFloat(this.field.getAttribute(attrs.maxLength) || '0') || 0
        this.minLength =
            parseFloat(this.field.getAttribute(attrs.minLength) || '0') || 0

        this.fieldMessage = this.getElement(
            `.${commonClass.formFieldMessageError}`,
            this.field
        )

        this.counterValueWrap = this.getElement(
            `.${className.formFieldMessageCount}`,
            this.field
        )

        this.counterValue = this.getElement(`[${attrs.value}]`, this.field)

        this.countCharacters()

        this.count.addEventListener(EventType.KEYDOWN, () => {
            this.countCharacters()
        })
    }

    public countCharacters(): void {
        const textCount = this.count.value.length

        // update UI with length of question characters
        if (this.counterValue) {
            this.counterValue.textContent = textCount.toString()
        }

        if (this.field.classList.contains(commonClass.formFieldError)) {
            this.hideMaxErrorMessage()
        }

        // display error when max length is reached
        if (this.maxLength && textCount > this.maxLength) {
            this.showMaxErrorMessage()
        }

        // display error if min length is not fulfilled
        if (this.minLength && textCount !== 0 && textCount < this.minLength) {
            this.showMinErrorMessage()
        }
    }

    private hideMaxErrorMessage(): void {
        this.field.classList.remove(commonClass.formFieldError)
        if (this.counterValueWrap) {
            this.counterValueWrap.classList.remove(
                className.formFieldMessageCountError
            )
        }

        if (this.fieldMessage) {
            this.fieldMessage.innerHTML = ''
        }
    }

    private showMaxErrorMessage(): void {
        this.field.classList.add(commonClass.formFieldError)
        if (this.counterValueWrap) {
            this.counterValueWrap.classList.add(
                className.formFieldMessageCountError
            )
        }

        if (this.fieldMessage) {
            this.fieldMessage.innerHTML = `
                <ul class="errorlist">
                    <li>You have reached maximum characters</li>
                </ul>`
        }
    }

    private showMinErrorMessage(): void {
        this.field.classList.add(commonClass.formFieldError)
        if (this.counterValueWrap) {
            this.counterValueWrap.classList.add(
                className.formFieldMessageCountError
            )
        }

        if (this.fieldMessage) {
            this.fieldMessage.innerHTML = `
                <ul class="errorlist">
                    <li>Minimum ${this.minLength} characters needed</li>
                </ul>`
        }
    }
}
